import { render } from "./AdNtBig01.vue?vue&type=template&id=0192d006&scoped=true"
import script from "./AdNtBig01.vue?vue&type=script&lang=js"
export * from "./AdNtBig01.vue?vue&type=script&lang=js"

import "./AdNtBig01.vue?vue&type=style&index=0&id=0192d006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0192d006"]])

export default __exports__